import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fileInput", "addFilesForm", "renameModal", "renameForm", "newNameInput"]

  showFileInput() {
    this.fileInputTarget.click()
  }

  submitFiles() {
    if (this.fileInputTarget.files.length > 0) {
      this.addFilesFormTarget.submit()
    }
  }

  openRenameModal(event) {
    const { blobId, filename, url } = event.params
    this.newNameInputTarget.value = filename
    this.renameFormTarget.action = url
    
    // If Bootstrap is available globally
    const modal = new bootstrap.Modal(this.renameModalTarget)
    modal.show()
  }

  submitRename() {
    const modalInstance = bootstrap.Modal.getInstance(this.renameModalTarget)
    if (modalInstance) {
      modalInstance.hide()
    }
  }
}
